/**
 * Scroll Carousel Helper
 * Generic helper for managing scroll-shadow carousels across sections
 */

if (!customElements.get('scroll-carousel-helper')) {
  class ScrollCarouselHelper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      setTimeout(() => {
        this.container = this.querySelector('[data-scroll-container]');
        this.scrollShadow = this.querySelector('scroll-shadow');
        this.progressBar = this.querySelector('.scroll-progress-bar');
        this.progressWrapper = this.querySelector('.scroll-progress');
        this.columnsDesktop = parseInt(this.dataset.columns || 4);
        this.itemsCount = parseInt(this.dataset.itemsCount || 0);
        
        if (!this.container) return;

        // Set up scroll progress tracking
        if (this.container && this.progressBar) {
          this.updateProgress();
          this.container.addEventListener('scroll', () => this.updateProgress());
        }
        
        // Check initial state after scroll-shadow initializes
        setTimeout(() => {
          this.navButtons = this.scrollShadow?.shadowRoot?.querySelectorAll('.nav-button');
          this.checkScrollNeeded();
        }, 200);

        // Re-check on window resize
        window.addEventListener('resize', () => {
          this.checkScrollNeeded();
        });
      }, 20);
    }

    checkScrollNeeded() {
      if (!this.container) return;
      
      const visibleItems = this.container.querySelectorAll('.scroll-item:not(.hidden)');
      const itemCount = this.itemsCount || visibleItems.length;
      const needsScroll = itemCount > this.columnsDesktop;
      const isMobile = window.innerWidth < 768;
      
      // Re-query nav buttons from shadow DOM
      this.navButtons = this.scrollShadow?.shadowRoot?.querySelectorAll('.nav-button');
      
      // Toggle navigation buttons (only on desktop)
      if (this.navButtons && this.navButtons.length > 0) {
        this.navButtons.forEach(btn => {
          if (needsScroll || isMobile) {
            btn.classList.remove('force-hidden');
            btn.removeAttribute('style');
          } else {
            btn.classList.add('force-hidden');
            btn.style.display = 'none';
          }
        });
      }
      
      // Toggle progress bar (only hide on desktop when not needed)
      if (this.progressWrapper) {
        if (needsScroll || isMobile) {
          this.progressWrapper.style.display = '';
        } else {
          this.progressWrapper.style.display = 'none';
        }
      }
      
      // Toggle grid styling (only on desktop)
      if (!isMobile) {
        if (needsScroll) {
          this.container.classList.remove('no-scroll');
        } else {
          this.container.classList.add('no-scroll');
        }
      } else {
        this.container.classList.remove('no-scroll');
      }
    }

    updateProgress() {
      if (!this.container || !this.progressBar) return;
      
      const scrollLeft = this.container.scrollLeft;
      const scrollWidth = this.container.scrollWidth - this.container.clientWidth;
      const scrollPercent = scrollWidth > 0 ? (scrollLeft / scrollWidth) * 100 : 0;
      
      this.progressBar.style.width = scrollPercent + '%';
    }
  }
  customElements.define('scroll-carousel-helper', ScrollCarouselHelper);
}
